"use client";

import React, { createContext, useContext, useState, useEffect } from "react";
import api, { setAuthToken } from "../api/api";

const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);

  // -------------------------
  // 🔥 LOGOUT FUNCTION
  // -------------------------
  const logout = async () => {
    try {
      // Call Laravel logout API
      await api.post("/logout");
    } catch (e) {
      // Even if API fails, continue logout
      //console.warn("Laravel logout failed", e);
    }
    // Remove axios Authorization header
    setAuthToken(null);

    // Remove local storage user
    if (typeof window !== "undefined") {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("user");
      localStorage.removeItem("token");
    }

    // Delete auth cookie
    document.cookie ="auth_token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;";
    // Clear user state
    setCurrentUser(null);
  };

  // -------------------------
  // 🔥 AUTO LOAD USER
  // -------------------------
  useEffect(() => {
    if (typeof window === "undefined") return;

    const token = localStorage.getItem("auth_token");
    const savedUser = localStorage.getItem("user");

    // 🔹 Safely restore user from localStorage
    if (savedUser) {
      try {
        const parsedUser = JSON.parse(savedUser);
        if (parsedUser && typeof parsedUser === "object") {
          setCurrentUser(parsedUser);
        }
      } catch (err) {
        console.error("Invalid user JSON:", err);
        localStorage.removeItem("user");
      }
    }

    // 🔹 If no token → stop here
    if (!token) {
      setLoadingUser(false);
      return;
    }

    // 🔹 Load token into axios
    setAuthToken(token);

    // 🔹 Validate user via /me API
    api
      .get("/me")
      .then((res) => {
        if (res.data) {
          setCurrentUser(res.data);
        }
      })
      .catch((err) => {
        console.error("Token invalid — logging out", err);
        logout();
      })
      .finally(() => {
        setLoadingUser(false);
      });
  }, []);

  // -------------------------
  // 🔥 LOGIN FUNCTION
  // -------------------------
  const login = (userData, token) => {
    if (typeof window === "undefined") return;

    // Store token
    localStorage.setItem("auth_token", token);
    //localStorage.setItem("user", JSON.stringify(userData));

    // Set axios header
    setAuthToken(token);

    // Update state
    setCurrentUser(userData);
  };

  return (
    <DataContext.Provider value={{ currentUser, setCurrentUser, login, logout, loadingUser }}>
      {!loadingUser && children}
    </DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext);
